import type {PropsWithChildren, ReactNode} from "react";

export function WorkspaceShell({context, navigation, children}: PropsWithChildren<{
  context: ReactNode;
  navigation?: ReactNode;
}>) {
  return <article className="object-workspace">
    {context}
    {navigation && <nav className="workspace-sections" aria-label="Workspace sections">{navigation}</nav>}
    <div className="workspace-content">{children}</div>
  </article>;
}
